import { ClientOrderTrackingShipmentFolder } from "@redotech/redo-views-common/folders";
import { ClientOrderTrackingShipmentView } from "@redotech/redo-views-common/views";
import * as z from "zod";
import { null as zNull } from "zod";

export const getOrderTrackingViewsAndFolders = {
  name: "getOrderTrackingViewsAndFolders" as const,
  input: zNull(),
  output: z.object({
    folders: z.array(ClientOrderTrackingShipmentFolder),
    views: z.array(ClientOrderTrackingShipmentView),
  }),
};
